<template>
<div class="container element-margin">
  <div class="titleBox">
  <h2 class="text-center text-muted flow-title align-self-center">
    Vehicle details
  </h2>
</div>
  <b-container class="box shadow-sm col-sm-8 element-center">
    <div>
      <h3 v-if="qualifyAlert" id="alert">Sorry, the details you entered doesn't qualify for a repair payment plan</h3>
    </div>

    <b-row class="col-12 mt-3">
      <div class="col-8 mx-auto">
        <div v-if="!apiError">
        <select v-model="model.year" class="form-control" @change="yearChanged()">
          <option value="">Year</option>
          <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>
      <div v-else>
  <input v-model="model.year" class="form-control" placeholder="Type Year Here" />
</div>

<div v-if="!apiError">

        <select v-model="model.make" class="form-control" :disabled="!makes.length" @change="makeChanged()">
          <option value="">Make</option>
          <option v-for="make in makes" :key="make" :value="make">{{ make }}</option>
        </select>
      </div>
      <div v-else>
  <input v-model="model.make" class="form-control" placeholder="Type Make Here" />
</div>
<div v-if="!apiError">

        <select v-model="model.model" class="form-control" :disabled="!models.length" @change="modelChanged()">
          <option value="">Model</option>
          <option v-for="item in models" :key="item.name" :value="item.name">{{ item.name }}</option>
        </select>
      </div>
      <div v-else>
  <input v-model="model.model" class="form-control" placeholder="Type Model Here" />
</div>
<!-- <div v-if="!apiError">

        <select v-model="model.trim" class="form-control" :disabled="!trims.length">
          <option value="">Trim level</option>
          <option v-for="trim in trims" :key="trim" :value="trim">{{ trim }}</option>
        </select>
      </div>
      <div v-else>
  <input v-model="model.trim" class="form-control" placeholder="Type Trim Here" />
</div> -->

      </div>
    </b-row>
    <!-- <b-row>
      <div class="col-12 separator mx-auto mt-4">
        <div class="line mb-4"></div>
        <div class="or">OR by VIN</div>
        <div class="line mt-4"></div>
      </div>
      <div v-show="!loading" class="col-md-12 col-sm-12 vin-container element-center">
        <div class="col-8 element-margin mx-auto">
          <input v-model="vin" type="text" placeholder="Enter VIN (If vehicle not found)" class="form-control vin col-12" :disabled="loading">
        </div>
      </div>
    </b-row> -->

    <!-- <b-row>

      <div class="col-12">
        <input v-model="odometer" type="number" :style="computedInputStyleEnable" class="form-control odo" placeholder="Odometer in KM" :disabled="loading">
      </div>
      <b-row v-show="odoerrview" class="mt-2 mx-auto">
        <b-col>
          <b-alert show variant="danger">Sorry, the mileage is too high :(</b-alert>
        </b-col>
      </b-row>


    </b-row> -->

<button
  :disabled="(!model.year || !model.make || !model.model) || !odometer || loading"
  class="btn btn-success mb-5"
  @click="submit"
>
  Next
</button>

    <b-row v-show="loading" align-h="center" class="mt-3">
      <b-col cols="6">
        <!-- <Loading
            v-if="loading"
            color="purple"
          /> -->
        <div class="spinner-border text-success" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </b-col>

    </b-row>

    <div class="error hide">
      <div class="d-flex justify-content-center mt-2">
                  <span style="color: red">Vehicle not found, please call</span>

      </div>
        <div class="d-flex justify-content-center">
            <a class="tel" href="tel:+1-604-245-6680">(604) 245-6680</a>.

          </div>
    </div>
  </b-container>
</div>
</template>

<script>
import $ from 'jquery'
import Loading from '../components/loading'

export default {
  name: 'VinAndMiles',
  components: {
    Loading,
  },
  data() {
    return {
      apiError: false, // Add this property to track API errors
      makes: [],
      models: [],
      trims: [],
      payment: '',
      vin: '',
      qualifyAlert: false,
      odometer: 90000,
      styleObjectGreen: {
        border: '2px solid green',
        // backgroundColor: 'lightgreen'
      },
      styleOBjectRed: {
        border: '2px solid red',
        // backgroundColor: 'pink'
      },
      model: {
        year: '',
        make: '',
        model: '',
        trim: 'Classic',
      },
      years: [
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024,
        2025,
      ],
      loading: false,
      odoerrview: false,
    }
  },
  computed: {
    computedInputStyleEnable() {
      // or use one method instead of computed property
      // apply your own logic at here to determinate if enable input-has-value-style
      return this.odometer && this.odometer.length > 0 ? this.styleObjectGreen : this.styleOBjectRed
    },
  },
  watch: {
    odometer: function() {
      if (this.odometer < 300000) {
        return (this.odoerrview = false)
      }
    },
  },
  mounted() {
    $('.navbar').addClass('darkHeader')
    console.log(this.$store.state.userData)
  },

  methods: {
    yearChanged() {
      const { year } = this.model
      this.model = {
        year,
        make: '',
        model: '',
        trim: 'Classic',
      }
      this.makes = []
      this.models = []
      this.trims = []
      if (!year) return
      this.axios
        .get(`${process.env.ROOT_API}/vehicle/search/makes?year=${year}`)
        .then(({ data }) => {
          const { makes } = data
          this.makes = makes
        })
        .catch(() => {
          this.apiError = true // Set apiError to true if there's an error
        })
    },
    makeChanged() {
      const { year, make } = this.model
      this.model = {
        year,
        make,
        model: '',
        trim: 'Classic',
      }
      this.models = []
      this.trims = []
      if (!make) return
      this.axios
        .get(`${process.env.ROOT_API}/vehicle/search/models?year=${year}&make=${make}`)
        .then(({ data }) => {
          const { models } = data
          this.models = models
        })
        .catch(() => {
          this.apiError = true
        })
    },
    modelChanged() {
      const { year, make, model } = this.model
      this.model = {
        year,
        make,
        model,
        trim: 'Classic',
      }
      this.trims = []
      if (!model) return

      const fetchTrims = new Promise((resolve, reject) => {
        this.axios
          .get(
            `${process.env.ROOT_API}/vehicle/search/trims?year=${year}&make=${make}&model=${model}`
          )
          .then(({ data }) => {
            const { trims } = data
            resolve(trims)
          })
          .catch(() => {
            reject(new Error('API error'))
          })
      })

      const timeout = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), 700)
      )

      Promise.race([fetchTrims, timeout])
        .then(trims => {
          this.trims = trims
        })
        .catch(error => {
          this.apiError = true
          console.error(error.message)
        })
    },

    submit() {
      $('.error').addClass('hide')
      if (this.apiError) {
        const { year, make, model, trim } = this.model
        this.$store.state.userData.marketValue = 30000
        this.$store.state.userData.year = year
        this.$store.state.userData.make = make
        this.$store.state.userData.model = model
        this.$store.state.userData.trim = trim
        this.$store.state.userData.carDetails = `${this.model.year} ${this.model.make} ${
          this.model.model
        }`
        this.$store.state.userData.approvedLoanAmount = 10000
        this.$store.state.userData.odometerReading = 345
        console.log(this.$store.state.userData)
        this.$router.push({
          name: 'SelectVendor',
        })
        return
      }
      if ((this.vin.length !== 17 && !this.model.trim) || !this.odometer || this.loading) {
        return
      }
      if (this.odometer > 300000) {
        this.odoerrview = true
      } else {
        this.loading = true
        this.qualifyAlert = false
        this.$store.state.userData.vin = this.vin
        this.$store.state.userData.odometerReading = this.odometer
        const odometer = Math.round(this.odometer * 0.62)
        const { year, make, model, trim } = this.model
        this.$store.state.userData.year = year
        this.$store.state.userData.make = make
        this.$store.state.userData.model = model
        this.$store.state.userData.trim = trim

        if (year < 2018) {
          const url = this.vin
            ? `${process.env.ROOT_API}/vehicle/value?mileage=${odometer}&vin=${this.vin}`
            : `${
                process.env.ROOT_API
              }/vehicle/value?mileage=${odometer}&year=${year}&make=${make}&model=${model}&trim=${trim}`
          this.axios
            .get(url)
            .then(response => {
  const {
    mean,
    success,
    car_details: carDetails,
    certainty,
    max_loan_amount,
    low,
    high,
  } = response.data

  if (!success) throw new Error('An error occurred')

  // backend should already be 0-100; keep safe
  const certaintyScore = certainty <= 1 ? Math.round(certainty * 100) : certainty

  // ✅ store values
  this.$store.state.userData.marketValue = mean
  this.$store.state.userData.carDetails = carDetails
  this.$store.state.userData.marketValueLow = low
  this.$store.state.userData.marketValueHigh = high

  // ✅ use server-approved amount (and enforce at least 1500)
  const rawMax = typeof max_loan_amount === 'number' ? max_loan_amount : 0
  const approved = Math.min(Math.max(rawMax, 1500), 10000)

  this.$store.state.userData.max_loan_amount = rawMax
  this.$store.state.userData.approvedLoanAmount = approved

  // ✅ move forward (do NOT block on "approvedLoan > 500")
  if (carDetails && carDetails.substring(0, 4) > 2002 && odometer < 220000 && certaintyScore > 20) {
    this.odometer = odometer
    this.$router.push({ name: 'SelectVendor' })
  } else {
    // if you truly want "always approve 1500", you can still proceed even if checks fail
    // but keeping your year/odo/certainty gating:
    this.qualifyAlert = true
    this.loading = false
    this.vin = ''
    this.model = { year: '', make: '', model: '', trim: 'Classic' }
    this.odometer = null
  }
})


.catch(() => {
  this.$store.state.userData.marketValue = 20000
  this.$store.state.userData.carDetails = year.toString().concat(' ', make, ' ', model)

  this.$store.state.userData.max_loan_amount = 1500
  this.$store.state.userData.approvedLoanAmount = 1500

  this.loading = false
  this.$router.push({ name: 'SelectVendor' })
})
        } else {
          this.$store.state.userData.marketValue = 30000
          this.$store.state.userData.carDetails = year.toString().concat(' ', make, ' ', model)
          this.approvedLoan = 10000
          this.$store.state.userData.approvedLoanAmount = this.approvedLoan
          this.$router.push({
            name: 'SelectVendor',
          })
        }
      }
    },
  },
}
</script>

<style scoped>
@media (max-width: 560px) {
  .titleBox {
    padding-top: 1rem;
  }
}

.lds-roller {
  position: absolute !important;
  display: inline !important;
  right: 120px;
}
.titleBox {
  padding-top: 2rem;
}
.error {
  padding: 15px 0;
  color: red;
}

.error.hide {
  display: none;
}

.flow-title {
  padding-top: 5rem;
}

.element-margin {
  margin-bottom: 8%;
  text-align: center;
}

.element-center {
  margin: 0 auto;
}

.container {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.box {
  /* padding: 6rem; */
  border-top: 3px solid #40c991;
  padding-bottom: 3px;
}

.box .separator .line {
  width: 1px;
  height: 10%;
  background-color: #a803a8;
  margin: 0 auto;
}

.box .separator .or {
  margin: 0 auto;
  width: fit-content;
  height: 20%;
  display: flex;
  align-items: center;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 3rem;
}

select,
input {
  margin-top: 1.5rem;
  border-radius: 1rem;
}

input.vin {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

select:focus,
input:focus {
  box-shadow: none;
}

input.odo {
  width: 250px;
  max-width: 250px;
  margin: 20px auto 0 auto;
}

.odo select {
  width: 70px;
}

#alert {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/vin_and_miles.vue